import { render, staticRenderFns } from "./CurrentTenantsStat.vue?vue&type=template&id=a620c230&"
import script from "./CurrentTenantsStat.vue?vue&type=script&lang=js&"
export * from "./CurrentTenantsStat.vue?vue&type=script&lang=js&"
import style0 from "./CurrentTenantsStat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports